import Awards from "@/components/sections/Awards";
import CTA from "@/components/sections/CTA";
import Clients from "@/components/sections/Clients";
import HomeCTA from "@/components/sections/HomeCTA";
import HomeHero from "@/components/sections/HomeHero";
import HomeInfo from "@/components/sections/HomeInfo";
import HomeNews from "@/components/sections/HomeNews";
import HomeProjects from "@/components/sections/HomeProjects";
import HomeTeam from "@/components/sections/HomeTeam";
import HomeWWD from "@/components/sections/HomeWWD";
import cmsClient from "@/lib/cmsClient"
import gsap from "gsap";
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Head from "next/head";
import WrapperBg from "../components/layout/WrapperBg";
import BGColorChangeWrapper from "../components/layout/BGColorChangeWrapper";
import ScrollToTopChecker from "../components/layout/ScrollToTopChecker";
import Header from "@/components/layout/Header";
import FormPOPUP from "@/components/ui/FormPOPUP";
import Footer from "@/components/layout/Footer";

 gsap.registerPlugin(ScrollTrigger);

export async function getStaticProps({ locale }) {
  try {
    const [data, globalData] = await Promise.all([
      cmsClient("page/homepage", {}, { lang: locale }),
      cmsClient("general", {}, { lang: locale }),
    ]);

    return {
      props: {
        data,
        globalData,
      },
    };
  } catch (error) {
    return {
      props: {
        data: null,
        globalData: null,
      },
    };
  }
}


export default function Home({ data, globalData }) {

  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
  const acf = data.acf

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Санкт-Петербург, Россия",
        "postalCode": "197198",
        "streetAddress": "Малый проспект П.С., д. 5 литер Б, офис 404",
        "addressCountry" : "RU"
      },
      "email": "info@designic.com",
      "name": "Designic",
      "logo": "https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-192x192.jpg",
      "image": "https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-270x270.jpg",
      "telephone": "+7 921 915 60 83"
  };

  return (
    <>
      <Head>
        <title>{data.seo.title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" key={'viewport-custom'}/>
        <meta charSet="UTF-8"/>
	      <meta httpEquiv="X-UA-Compatible" content="IE=edge"></meta>
        <link rel="profile" href="https://gmpg.org/xfn/11"></link>
        {/* <meta name="robots" content="noindex, nofollow" /> */}
        <meta name="description" content={data.seo.description}/>
        <meta name="robots" content="max-image-preview:large"/>
        <link rel="canonical" href={baseUrl}/>
        <meta property="og:locale" content="ru_RU"/>
        <meta property="og:site_name" content={data.seo.og.site_name}/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={data.seo.og.title}/>
        <meta property="og:description" content={data.seo.og.description}/>
        <meta property="og:url" content="https://designic.com/"/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content={data.seo.title}/>
        <meta name="twitter:description" content={data.seo.description}></meta>

        <link rel="alternate" hrefLang="ru" href={baseUrl}/>
        <link rel="alternate" hrefLang="en" href={`${baseUrl}/en/`}/>
        <link rel="alternate" hrefLang="x-default" href={baseUrl}/>

        <link rel="icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-32x32.jpg" sizes="32x32"/>
        <link rel="icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-192x192.jpg" sizes="192x192"/>
        <link rel="apple-touch-icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-180x180.jpg"/>
        <meta name="msapplication-TileImage" content="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-270x270.jpg"></meta>
        <script
          type="application/ld+json"
          className="aioseo-schema"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>

      <ScrollToTopChecker/>
      <Header headerData={globalData.header}/>
      <FormPOPUP title={data?.cta_title} formInfo={globalData.form} formResponse={globalData?.['form-response']}/>
      <WrapperBg>
        <BGColorChangeWrapper colorClass={'bg-beige'}>
          {acf.hero_status && (
            <HomeHero image={acf.hero_image} text={acf.hero_texts} title={acf.hero_title}/>
                      )}
          <HomeInfo title={acf.about_hp_title} text={acf.about_hp_text} image={acf.about_hp_image} people={acf.about_hp_peoples}/>
          <HomeProjects btn_text={acf.portfolio_btn_text} btn_item_text={acf.portfolio_item_btn_text} title={acf['what-we-do_title']} items={acf.portfolio_items} text={acf['what-we-do_subtitle']}/>
        </BGColorChangeWrapper>
        <BGColorChangeWrapper colorClass={'bg-sky-blue'}>
          {acf.clients_status && (
            <Clients clients_items={acf.clients_items} title={acf.clients_title} text={acf.clients_subtitle}/>
              )}
          <HomeWWD items={acf['what-we-do_items']} btn_text={acf['what-we-do_btn']}  title={acf.portfolio_title} text={acf.portfolio_text}/>
          <HomeCTA text={acf.cta_desc} image={acf.cta_image} title={acf.cta_title} buttonText={acf.cta_btn_text} lang={globalData?.language} menu={globalData.header?.menu}/>
        </BGColorChangeWrapper>
        <BGColorChangeWrapper colorClass={'bg-beige'}>
          <HomeTeam image={acf.cta_change_image_additional} gallery={acf.home_team_images} btnLink={acf.home_team_btn_link} btnText={acf.home_team_btn_text} text={acf.home_team_text} title={acf.home_team_title}/>

        {acf.awards_status && (
          <Awards title={acf.awards_title} text={acf.awards_desc} items={acf.awards_items} />
        )}
        {acf.news_status ? 
          <HomeNews news={acf.news_items} title={acf.news_title} text={acf.news_text} buttonLink={acf.news_btn_link} buttonText={acf.news_btn_text}/> : <div className="w-full lg:h-[9vw] xl:h-[10vw]"></div>
        }
        </BGColorChangeWrapper>
        <BGColorChangeWrapper colorClass={'bg-sky-blue'}>
          {globalData?.language !== 'en' && (
              <CTA title={data?.cta_title} image={data?.cta_image} formInfo={globalData.form} formResponse={globalData?.['form-response']} bottomTitle={data?.cta_seo.title} isBottomSectionNeed={true} bottomText1={data?.cta_seo?.text?.[0].text} bottomText2={data.cta_seo.text?.[1].text}/>
          )}
        </BGColorChangeWrapper>
      </WrapperBg>
      <Footer footerData={globalData.footer} social={globalData.socials} />
    </>
  );
}


